import type { PublicStudioListVM } from "@shared-kernel/application/ports/public/public-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrievePublicStudios = createApiThunk<PublicStudioListVM[], void>(
  "shared/studios/retrieve-public",
  async (_, { extra: { publicRepository } }) => {
    return publicRepository!.getPublicStudios();
  },
);
